<template>
  <div class="open-time">
    <h1 class="m-font-1">入馆须知</h1>
    <div class="open-content">
      <!-- <div class="date ml-40">免费开放，须提前预约门票</div> -->

      <!--      <div class=" child-hall">
        <div class="date" style="margin-bottom: 22px;">预约方式</div>
        <div class="week  mb-10">我馆实行实名认证在线预约订票方式</div>
        <div class="flex-box">

          <div class="icon-item">
            <div class="close">微信小程序预约</div>
            <img src="../../assets/images/icon_Applet@2x.png" alt="">
            <div class="pic-pop anim">
              <div class="pic">
                <img src="@images/wechat.jpg" alt="" title="">
              </div>
            </div>
          </div>

          <div class="icon-item">
            <div class="close">微信公众号预约</div>
            <img src="../../assets/images/icon_wechat@2x.png" alt="">
            <div class="pic-pop anim">
              <div class="pic">
                <img src="@images/code-wechat.png" alt="" title="">
              </div>
            </div>
          </div>

          <div class="icon-item">
            <div class="close">支付宝小程序预约</div>
            <img src="../../assets/images/icon_zhifubao@2x.png" alt="">
            <div class="pic-pop anim">
              <div class="pic">
                <img src="@images/alipay.jpg" alt="" title="">
              </div>
            </div>
          </div>

        </div>
      </div>-->

      <div class="box">
        <!-- <div class="date mb-23">预约注意事项</div> -->
        <!--  <!~~ “数字辽博”小程序、 ~~>
        <p>1、观众可通过“辽博预约”微信小程序、“辽宁省博物馆”微信公众号或“辽宁省博物馆预约”支付宝小程序进行门票预约；</p>
        <p>2、参观门票当日当次有效；</p>
        <p>
          3、观众凭本人二代身份证按照预约系统提示操作进行预约，每个证件号每日限定预约1张参观门票（可携带1名6岁或1.4m以下儿童参观），每个账户每天限定预约5张门票，认真填写身份信息，选择参观日期、参观时段、门票数量，确认信息填写无误后，提交订单；
        </p>
        <p>4、前往儿童体验馆参观体验的观众（儿童年龄范围：3 - 12 岁）需同时预约辽宁省博物馆参观门票，否则无法入馆。</p>-->
        <p>
          1.为切实提高观众参观博物馆便利水平，辽宁省博物馆自2024年7月20日起，取消预约制参观，广大观众可以直接到馆，请持本人身份证刷证入馆。儿童、持护照的境外游客可通过专门通道入馆。未持有效身份证件的观众请现场扫码进入系统登记后入馆。
        </p>
        <p>
          2.为确保文物安全和参观秩序，馆内观众流量达到瞬时承载量峰值时，将暂缓放行，敬请理解和配合相关工作。
        </p>
        <p>
          3.70周岁（含70周岁）以上老年人、残疾人、现役军人凭有效证件可优先入馆。
        </p>
        <p>
          4.观众进馆参加活动（包括辽博讲堂、儿童体验馆，“博物少年说”青少年研学体验营暨2024年辽博暑期小讲解员培训班、“维多利亚的下午茶”特色讲解活动、博谈雅集“多彩非遗·粉墨神韵”专场活动等），需进行活动报名或预约。
        </p>
      </div>

      <div class="flex-img-box">
        <div class="img-item">
          <img src="../../assets/images/activity_code.png" alt="">
          <span>活动预约二维码</span>
        </div>

        <div class="img-item">
          <img src="../../assets/images/ertong_code.png" alt="">
          <span>儿童馆预约二维码</span>
        </div>

      </div>

      <!-- <div class="child-hall">
        <div class="date" style="margin-bottom: 18px;">参观流程</div>
        <p>
          1、预约「辽宁省博物馆」的观众请在参观当日的预约时间段内，携带本人二代身份证，在西门入口处，扫描身份证进馆参观；
        </p>
        <p>
          2、预约「儿童体验馆」的观众请在参观当日的预约时间段内，凭预约码在儿童体验馆入口处验码进馆参观。
        </p>
      </div> -->

    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      focusList: [
        {
          name: '微博',
          url: require('@images/foot-webo.png'),
          qrcode: require('@images/code-weibo.png'),
        },
        {
          name: '微信',
          url: require('@images/foot-wechat.png'),
          qrcode: require('@images/code-wechat.png'),
        },
        // {
        //   name: '链接',
        //   url: require('@images/foot-link.png'),
        //   qrcode: require('@images/foot-webo.png'),
        // },
        {
          name: '抖音',
          url: require('@images/foot-douyin.png'),
          qrcode: require('@images/code-douyin.png'),
        },
      ],
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.open-time {
  width: 100%;

  .flex-img-box {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 38px 126px 38px 40px;
    background: #f6f6f6;
    padding: 38px 40px 37px;

    .img-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 18px;
      color: #000000;

      img {
        width: 200px;
        height: 200px;
        margin-bottom: 12px;
      }

      &:last-child {
        margin-left: 160px;
      }
    }

  }

  h1 {
    margin-bottom: 55px;
    // font-size: 44px;
    font-weight: 400;
    color: #000000;
  }

  .open-content {
    .date {
      font-size: 24px;
      font-weight: 400;
      color: #000000;

      &.mb-23 {
        margin-bottom: 23px;
      }
    }

    .ml-40 {
      margin-left: 40px;
    }

    .week,
    .close {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
    }

    .child-hall {
      background: #f6f6f6;
      padding: 38px 40px 37px;
      margin: 38px 0;
    }

    .flex-box {
      font-size: 16px;
      color: #000000;

      .icon-item {
        position: relative;
        margin-right: 78px;
        cursor: pointer;

        img {
          width: 54px;
          height: 54px;
          margin-top: 23px;
          object-fit: contain;
        }

        .pic-pop.anim {
          position: absolute;
          left: -50px;
          bottom: 66%;
          margin-bottom: 10px;
          opacity: 0;
          padding: 8px;
          visibility: hidden;
          border-radius: 5px;
          // transition: all 0.3s;
          background: #fff;

          &::before {
            content: '';
            width: 12px;
            height: 12px;
            background-color: #fff;
            border: 1px solid #ddd;
            position: absolute;
            z-index: 1;
            left: 50%;
            top: 100%;
            transform: translate(-50%, -50%) rotate(45deg);
          }

          &:after {
            content: '';
            position: absolute;
            z-index: 2;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            border-radius: 5px;
          }

          .pic {
            position: relative;
            z-index: 3;
            width: 137px;

            img {
              width: 100%;
              height: 137px;
            }
          }
        }

        &:hover {
          .pic-pop {
            opacity: 1;
            visibility: visible;
          }

          // .pic-pop.anim {
          //   transform: translate(-50%, 0%);
          // }
        }
      }

      .item {
        display: flex;
        flex-direction: column;
        margin-right: 78px;

        img {
          margin-top: 22px;
          width: 55px;
          height: 55px;
        }
      }
    }

    .close {
      display: flex;
      align-items: center;

      &::before {
        content: '';
        display: block;
        background: #ae8148;
        position: relative;
        top: 1px;
        width: 3px;
        height: 17px;
        margin-right: 9px;
      }
    }

    .box {
      margin: 34px 126px 72px 40px;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 38px;
    }
  }
}
</style>